<template>
  <div class="header">
    <img src="../assets/img/logo.png" />
    <el-dropdown trigger="click" @command="handleCommand">
      <el-button type="primary" size="small" round>
        <div class="switch-content">
          <img src="../assets/img/languageIcon.svg" />
          {{ languageType }}
          <i class="el-icon-arrow-down el-icon--right"></i>
        </div>
      </el-button>
      <template #dropdown>
        <el-dropdown-menu>
          <el-dropdown-item
            v-for="(item, index) in languageOptions"
            :key="index"
            :command="item"
            >{{ item.languageName }}</el-dropdown-item
          >
        </el-dropdown-menu>
      </template>
    </el-dropdown>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { getLanguageList } from "../api/index.js";

export default {
  data() {
    return {
      languageOptions: [], // 用于存储语言选项列表
    };
  },
  computed: {
    ...mapState("language", ["languageType"]), // 从 Vuex 中映射当前语言
  },
  methods: {
    ...mapActions("language", ["setLanguage"]), // Vuex 的 setLanguage 方法
    handleCommand(command) {
      // 切换语言并更新 Vuex 中的语言状态
      this.setLanguage(command.languageName);
    },
  },
  created() {
    // 获取语言选项列表
    getLanguageList({ status: 1000 }).then((res) => {
      if (res.success) {
        this.languageOptions = res.data || [];
      }
    });
  },
};
</script>

<style scoped>
.header {
  width: 100%;
  height: 100%;
  padding: 0 0 0 10%;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
.switch-content {
  display: flex;
  flex-direction: row;
  align-items: center;
  column-gap: 12px;
  font-size: 16px;
}
</style>
